/*
 * @Description: 日程管理 - 会场API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取会场列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getVenueList(params) {
  return request({
    url: '/schedule/venue/list',
    method: 'get',
    params
  })
}

/**
 * 添加会场
 * @param {Object} data - 会场数据
 * @returns {Promise}
 */
export function addVenue(data) {
  return request({
    url: '/schedule/venue/add',
    method: 'post',
    data
  })
}

/**
 * 编辑会场
 * @param {Object} data - 会场数据
 * @returns {Promise}
 */
export function editVenue(data) {
  return request({
    url: '/schedule/venue/edit',
    method: 'post',
    data
  })
}

/**
 * 删除会场
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteVenue(data) {
  return request({
    url: '/schedule/venue/delete',
    method: 'post',
    data
  })
}

/**
 * 获取会场详情
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function getVenueDetail(data) {
  return request({
    url: '/schedule/venue/detail',
    method: 'post',
    data
  })
}

/**
 * 更新会场排序
 * @param {Object} data - 排序数据
 * @returns {Promise}
 */
export function updateVenueSort(data) {
  return request({
    url: '/schedule/venue/updateSort',
    method: 'post',
    data
  })
}